export const LOADING_ITEMCATEGORY = "LOADING_ITEMCATEGORY";
export const GET_ITEMCATEGORY_LIST = "GET_ITEMCATEGORY_LIST";
export const GET_ITEMCATEGORY = "GET_ITEMCATEGORY";
export const REMOVE_ITEMCATEGORY = "REMOVE_ITEMCATEGORY";
export const ADD_ITEMCATEGORY = "ADD_ITEMCATEGORY";
export const UPDATE_ITEMCATEGORY = "UPDATE_ITEMCATEGORY";